var _excluded = ["barLinks"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { Fragment, memo } from "react";
import styled from "styled-components";
import useBreakpoint from "../../../../../../hooks/useBreakpoint";
import space from "../../../../../../utils/space";
import PlainLinkAtm from "../../../../../atoms/PlainLinkAtm";
import WrapOrg from "../../../../WrapOrg";
var BarLink = styled(PlainLinkAtm).withConfig({
  componentId: "sc-1ekikmx-0"
})(["position:relative;&::after{content:\"\";position:absolute;top:50%;right:", ";left:", ";height:", ";transform:translateY(-50%);}"], space(-1), space(-1), space(4));
function BarLinksOrg(_ref) {
  var barLinks = _ref.barLinks,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var isSmallOnly = useBreakpoint("small", "medium");
  return /*#__PURE__*/React.createElement(WrapOrg, _extends({
    gutterSpace: 3
  }, restProps), barLinks.map(function (barLink, index) {
    return barLink.isHiddenOnMobile && isSmallOnly ? null :
    /*#__PURE__*/
    // eslint-disable-next-line react/no-array-index-key
    React.createElement(Fragment, {
      key: "bar-link-".concat(index)
    }, /*#__PURE__*/React.createElement(BarLink, {
      href: barLink.href,
      to: barLink.to,
      title: barLink.title,
      typography: "tiny1",
      emphasis: "medium",
      type: "opacity",
      onClick: barLink.onClick,
      openInNewTab: barLink.openInNewTab
    }, barLink.text));
  }));
}
export default /*#__PURE__*/memo(BarLinksOrg);